module.exports = __webpack_public_path__ + "8aefc993de60cfa93e80194301567a15.png";